import { STATIC_STRINGS } from "@asez/shared";
import { GenericAutocomplete } from "@asez/component-library";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import { updateSkills } from "../../../../../store/steps/stepOneSlice";
import Modal from "@mui/material/Modal";
import { apiService } from "../../../services/apiService";
import { useParams } from "react-router-dom";

const AddSkillsModal = ({ isModalOpen, setModalOpen }) => {
  const { assessmentId } = useParams();
  const dispatch = useDispatch();
  const stepOne = useSelector((state: RootState) => state.stepOne);

  const handleConfirm = async () => {
    const data = {
      id: assessmentId as string,
      name: stepOne.title,
      role: stepOne.jobDesignation,
      yearsOfExperience: {
        min: stepOne.experience[0],
        max: stepOne.experience[1],
      },
      expertiseInSkills: stepOne.skills,
    };
    setModalOpen("");
    await apiService.addRequirements(data);
  };

  return (
    <Modal open={isModalOpen} onClose={() => setModalOpen("")}>
      <div className="border-2 border-neutral-dark h-1/3 w-1/3 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-md bg-white absolute flex flex-col justify-around items-center">
        <div className="w-[90%] mx-auto">
          <GenericAutocomplete
            options={[]}
            freeSolo={true}
            value={stepOne.skills}
            onChangeHandler={(event, newValue) =>
              dispatch(updateSkills([...newValue]))
            }
            placeholder={STATIC_STRINGS.SKILLS_PLACEHOLDER}
          />
        </div>
        <div className="w-[90%] mx-auto flex justify-center items-center">
          <button className="btn btn-outline" onClick={handleConfirm}>
            {STATIC_STRINGS.CONFIRM}
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default AddSkillsModal;
